<template>  
  <div class="shops">    
    <div v-if="shopsInfo.length > 0">
    <nna-card 
      v-for="shop in shopsInfo"
      :key="shop.oid"
      :id="shop.oid"      
      :name="shop.name"
      :category="shop.category"
      :city="shop.city"
      :image="shop.image" 
      :isOpen="shop.isOpen"       
    />
    </div>
    <div class="blankstate" v-else>
      <md-icon>sentiment_very_dissatisfied</md-icon>
      <h1 class="blankstate-title">Non abbiamo trovato referenze in questa zone, continua la tua ricerca le liste sono in continuo aggiornamento!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import nnaCard from '@/modules/common/components/card/Card'
export default {
  name: 'Shops',
  components: {
    nnaCard
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      shops: 'shops/shops',
      shopsSearched: 'shops/shopsSearched'
    }),
    shopsInfo() {      
      if(this.isShopsSearch) return this.shopsSearched && this.shopsSearched.list ? this.shopsSearched.list : ''
      return this.shops && this.shops.shopsInfo ? this.shops.shopsInfo : ''
    },
    isShopsSearch() {
      let search = this.$route.query
      console.log(search.date)
      console.log(search.lat)
      console.log(search.lng)
      return search.date && search.lat && search.lng
    }
  },
  methods: {
    ...mapActions({
      getShops: 'shops/getShops',
      searchShops: 'shops/searchShops'
    })
  },
  async mounted() {    
    if(this.isShopsSearch) {
      try {
        console.log("shops search")
        await this.searchShops(this.$route.query)
      } catch(err) {
        console.error(err)
      }
    }
    if(!this.shopsInfo) {
      console.log("my shops")
      this.getShops()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/common/components/list/Shops.vue